import React from 'react';
import { Navigate } from 'react-router-dom';

export const AdminConsolePage: React.FC = () => {
  // Redirect to monitor-chats as the default admin page
  return <Navigate to="/admin/monitor-chats" replace />;
};
